module.exports = __webpack_public_path__ + "static/media/11import-26.cd0b53d9.xlsx";